import { render, staticRenderFns } from "./_index_storehouse.vue?vue&type=template&id=3806dbbf&"
import script from "./_index_storehouse.vue?vue&type=script&lang=js&"
export * from "./_index_storehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports